import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {TokenService} from '../services/token.service';

@Injectable()
export class LoggedInGuard {
  constructor(
    private authService: TokenService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated()) {
      return this.router.navigate(['/']).then(() => {
        return false;
      });
    }

    return true;
  }
}
